var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "#E0E0E0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9059 14.2167C19.5261 13.3861 20.5574 11.9087 20.318 9.45345C20.0048 6.09262 17.2524 4.96672 13.6071 4.65267V0H10.7714V4.5233C10.0347 4.5233 9.28017 4.54205 8.52474 4.55986V0H5.68908V4.65267C4.64663 4.68454 3.43215 4.6686 0 4.65267V7.6807C2.23824 7.64132 3.41345 7.49695 3.68271 8.93597V21.6753C3.51162 22.8171 2.60006 22.653 0.571246 22.6174L0.000934868 25.9961C5.17113 25.9961 5.69095 26.0148 5.69095 26.0148V29.9991H8.52661V26.0701C9.2998 26.0889 10.0543 26.0889 10.7733 26.0889V30H13.6089V26.0157C18.3593 25.757 21.5353 24.557 21.9588 20.0703C22.2898 16.4704 20.5966 14.8636 17.9078 14.2177L17.9059 14.2167ZM8.5799 7.88413C10.1814 7.88413 15.1899 7.38539 15.1899 10.7275C15.1899 13.9214 10.1814 13.5521 8.5799 13.5521V7.88413ZM8.5799 22.6352V16.3945C10.4947 16.3945 16.3586 15.8592 16.3586 19.5144C16.3586 23.0412 10.4947 22.6343 8.5799 22.6343V22.6352Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.170f8eccb47c126ff5a289d276a8c48d.svg";
export { ForwardRef as ReactComponent };